import { render, staticRenderFns } from "./Notifications_Twitter.vue?vue&type=template&id=427ecd12&scoped=true&"
import script from "./Notifications_Twitter.vue?vue&type=script&lang=js&"
export * from "./Notifications_Twitter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427ecd12",
  null
  
)

export default component.exports